import { render, staticRenderFns } from "./PedidosListFilters.vue?vue&type=template&id=b4ba67ea&"
import script from "./PedidosListFilters.vue?vue&type=script&lang=js&"
export * from "./PedidosListFilters.vue?vue&type=script&lang=js&"
import style0 from "./PedidosListFilters.vue?vue&type=style&index=0&id=b4ba67ea&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports